import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 24px;
  width: 100%;
  margin-top: 24px;
`;

export const ImageLinkWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  & a {
    font-family: "Mulish", sans-serif;
    font-size: ${16 / 16}rem;
    color: ${({ theme }) => theme.palette.primary.blue500};
  }
`;

export const Image = styled.img`
  width: 120px;
  height: 120px;
`;

export const Title = styled.h6`
  font-family: "Inter", sans-serif;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.black.default};
  font-size: ${16 / 16}rem;
  margin-top: 24px;
  padding: 10px;
`;

export const Paragraph = styled.p`
  padding: 5px 10px;
  font-family: "Inter", sans-serif;
  font-size: ${14 / 16}rem;
  color: ${({ theme }) => theme.palette.greyscale.grey300};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 10px 0 10px 10px;
  }
`;
